import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Flyers() {
  return <ImageCollectionPage title="Flyers" path="/gallery/flyers" collection="gallery_flyers" />;
}
